import Vue from 'vue'
import { firestorePlugin } from 'vuefire'
import App from './App.vue'
// import './registerServiceWorker'
import createRouter from './router'
import store from './store'

Vue.use(firestorePlugin)

Vue.config.productionTip = false

export default function createApp() {
  const router = createRouter()
  const app = new Vue({
    router,
    store,
    head: {},
    render: h => h(App),
  }).$mount('#app')

  return { app, router }
}
